module.exports = __webpack_public_path__ + "img/visibility_black_24dp.5787ef1e.svg";